import React, { useEffect } from "react";
import { Box, Grid, useTheme } from "@mui/material";
import { Calendar } from "react-multi-date-picker";
import { formValue } from "../../services/formServiceFunctions";
import _ from "lodash";
import useForm, { UseFormProps } from "../../hooks/useForm";
import ValidatorForm from "../Validator/ValidatorForm";
import ButtonLoading from "../Button/ButtonLoading";
import ContentBox from "../ContentBox/ContentBox";
import { apiGet, apiPatch } from "../../services/Api/apiCall";
import calendarStyle from "./calendarStyle";
import { scrollToAnchor } from "../../theme/commonStyles";
import dayjs from "dayjs";

export default function HolidaySelection({}) {
  const initialValues = {
    holidays: [],
  };
  const onSubmit: UseFormProps["onSubmit"] = async ({ values }) => {
    const holidays = _.map(values.holidays, (holiday) => dayjs(holiday.toDate()).format("YYYY-MM-DD"));
    await apiPatch("holidays", 1, {
      holidays: holidays,
    });
  };

  const { values, handleChange, handleSubmit, updateAllValues, isLoading } = useForm({
    initialValues,
    onSubmit,
  });

  useEffect(() => {
    apiGet("holidays", 1).then((holidaysResource) => {
      const convertedHolidays = _.map(holidaysResource.holidays, (holidays) => dayjs(holidays).valueOf());
      updateAllValues({
        holidays: convertedHolidays,
      });
    });
  }, []);

  return (
    <>
      <Box sx={scrollToAnchor} id={"publicHolidays"} />
      <ContentBox headline="Feiertage einpflegen">
        <ValidatorForm onSubmit={handleSubmit}>
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Box sx={calendarStyle.calender}>
                <Calendar
                  value={formValue(values, "holidays")}
                  onChange={(dates) => {
                    void handleChange({
                      target: {
                        name: "holidays",
                        value: dates,
                      },
                    });
                  }}
                  showOtherDays
                  weekStartDayIndex={1}
                  weekDays={["S", "M", "D", "M", "D", "F", "S"]}
                  months={[
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember",
                  ]}
                  mapDays={({ date }) => {
                    const isWeekend = _.includes([0, 6], date.weekDay.index);
                    if (isWeekend) {
                      return {
                        disabled: true,
                      };
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid size={12}>
              <ButtonLoading isLoading={isLoading} variant="contained" type="submit">
                Speichern
              </ButtonLoading>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ContentBox>
    </>
  );
}
